// src/Components/Form2/CheckBoxList/CheckBoxList.js
import React from "react";
import css from "./CheckBoxList.module.css";
import FormLabel from "../FormLabel";

const CheckBoxList = ({ children, onChange }) => {
  if (!children) return null;

  const {
    label,
    required,
    id,
    infoImage,
    name,
    options = [],
    value,
  } = children;

  const handleChange = (val, checked) => {
    let newValue;

    // If value is array -> treat as multi-select
    if (Array.isArray(value)) {
      if (checked) {
        newValue = [...value, val];
      } else {
        newValue = value.filter((v) => v !== val);
      }
    } else {
      // If value is single -> treat as single choice (like yes/no)
      newValue = checked ? val : null;
    }

    onChange?.({ target: { name, value: newValue } });
  };

  if (!options.length) return null;

  return (
    <div className={css.CheckBoxList}>
      {label && (
        <FormLabel
          id={id || name}
          label={label}
          required={required}
          infoImage={infoImage}
          className={css.Label}
        >
          {label}
        </FormLabel>
      )}

      <div className={css.Options}>
        {options.map((opt) => {
          const checked = Array.isArray(value)
            ? value.includes(opt.value)
            : value === opt.value;

          return (
            <label key={opt.value} className={css.Option}>
              <input
                type="checkbox"
                name={name}
                value={opt.value}
                checked={checked}
                onChange={(e) => handleChange(opt.value, e.target.checked)}
              />
              <span className={css.Text}>{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default CheckBoxList;
